import { defaultTemplate } from 'app/features/contest/models/templates/default-template';
import { dtnTemplate } from 'app/features/contest/models/templates/dtn-template';
import { chronoTemplate } from './chrono-template';
import { cicTemplate } from './cic-template';
import { distanceTemplate } from './distance-template';
import { domyosTemplate } from './domyos-template';
import { dtn_wTemplate } from './dtn-w-template';
import { novonordiskTemplate } from './novo-nordisk-template';
import { tissotTemplate } from './tissot-template';

export const Templates = {
  default: defaultTemplate,
  chrono: chronoTemplate,
  distance: distanceTemplate,
  cic: cicTemplate,
  domyos: domyosTemplate,
  dtn: dtnTemplate,
  dtn_w: dtn_wTemplate,
  novonordisk: novonordiskTemplate,
  tissot: tissotTemplate,
};

export type TemplatesKeys = keyof typeof Templates;
